import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/shop/api";
import { PRODUCTS as STATIC_PRODUCTS } from "@/shop/products";

const ProductsContext = createContext({
  products: STATIC_PRODUCTS,
  getProduct: (slug) => STATIC_PRODUCTS.find((p) => p.slug === slug),
  loaded: false,
});

export const useProducts = () => useContext(ProductsContext);

export const ProductsProvider = ({ children }) => {
  const [products, setProducts] = useState(STATIC_PRODUCTS);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/shop/products`)
      .then((r) => {
        if (Array.isArray(r.data) && r.data.length) setProducts(r.data);
      })
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  const getProduct = (slug) => products.find((p) => p.slug === slug);

  return (
    <ProductsContext.Provider value={{ products, getProduct, loaded }}>
      {children}
    </ProductsContext.Provider>
  );
};
